import { Component, Input, Output } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { CustomersInterface } from '@careapp/angular-sdk';
import * as moment from 'moment';

import { DateAdapterShortString } from '../../../date-adapters/date-adater-string';
import { FormCoreComponent } from '../form-core';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL'
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};

@Component({
  selector: 'customer-form',
  styleUrls: ['./customer-form.component.scss'],
  templateUrl: './customer-form.component.html',
  providers: [
    { provide: DateAdapter, useClass: DateAdapterShortString },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class CustomerFormComponent extends FormCoreComponent<CustomersInterface> {
  // Date to open date picker at - Jan 1 1970 should save a bit of scrolling over the default of "today"
  startDate = '1970-01-01';

  @Input() queryString: string;
  @Input() locationLoading: boolean;

  @Input()
  set location(location) {
    if (location) {
      this.form.controls.location.patchValue(location);
    }
  }

  @Input()
  set customer(value: CustomersInterface) {
    if (value) {
      const result: any = { ...value };
      if (value.dateOfBirth) {
        result.dateOfBirth = value.dateOfBirth;
        this.startDate = value.dateOfBirth;
      }
      result.urls = result.urls || [];
      result.location = result.location || {};
      const groups = result.urls.map(
        url =>
          new FormGroup({
            url: new FormControl('', Validators.required),
            description: new FormControl('')
          })
      );
      this.form.setControl('urls', new FormArray(groups));
      this.form.patchValue(result, { emitEvent: false, onlySelf: true });
    } else {
      this.form.patchValue({}, { emitEvent: false, onlySelf: true });
    }
  }

  @Output() locationRequest = new EventEmitter<any>();

  setDate(value) {
    this.startDate = value;
    this.form.get('dateOfBirth').setValue(moment(value).format('YYYY-MM-DD'));
  }

  findLocation() {
    this.locationRequest.emit(this.form.controls.address.value);
  }

  addUrl() {
    this.form.setControl(
      'urls',
      new FormArray(
        (<FormArray>this.form.get('urls')).controls.concat(
          new FormGroup({
            url: new FormControl('', Validators.required),
            description: new FormControl('')
          })
        )
      )
    );
  }

  removeUrl(removed) {
    const controls = (<FormArray>this.form.get('urls')).controls.filter(
      control => control !== removed
    );
    this.form.setControl('urls', new FormArray(controls));
  }

  openUrl(item) {
    window.open(item.value.url, '_blank');
  }

  constructor() {
    super();
    this.form = new FormGroup({
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      enabled: new FormControl(true),
      dateOfBirth: new FormControl(null),
      about: new FormControl(''),
      profileImage: new FormControl(''),
      urls: new FormArray([]),
      settings: new FormGroup({
        allowMemoImages: new FormControl('')
      }),
      address: new FormGroup({
        address1: new FormControl(''),
        address2: new FormControl(),
        town: new FormControl(''),
        state: new FormControl(''),
        postcode: new FormControl(''),
        country: new FormControl('')
      }),
      location: new FormGroup({
        lat: new FormControl(''),
        lng: new FormControl()
      })
    });
  }
}
